/* H1HeadingBlock.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _12 = "@media not all and (min-width:30rem){._1qjn8pqr{font-size:2.5rem}}";
const _11 = "._1wyb1wto{font-size:3rem}";
const _10 = "._y3gn1h6o{text-align:center}";
const _9 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _8 = "._18u0idpf{margin-left:0}";
const _7 = "._otyridpf{margin-bottom:0}";
const _6 = "._2hwxidpf{margin-right:0}";
const _5 = "._19pkidpf{margin-top:0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Inline, media } from '@atlaskit/primitives';
import { H1, TextUnderline } from '@atlassian/mpac-primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._vchhusvi{box-sizing:border-box}";
const _3 = "._1bsb1osq{width:100%}";
const _2 = "._18zr1ejb{padding-inline:var(--ds-space-300,24px)}";
const _ = "._1rjc1rgp{padding-block:var(--ds-space-300,24px) var(--ds-space-500,40px)}";
const Wrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = Box,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1rjc1rgp _18zr1ejb _1bsb1osq _vchhusvi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Wrapper.displayName = 'Wrapper';
}
const Heading = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = H1,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8, _9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1fxt _y3gn1h6o _1wyb1wto _1qjn8pqr", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
export const H1HeadingBlock = () => /*#__PURE__*/_jsx(Wrapper, {
  as: "section",
  children: /*#__PURE__*/_jsx(Inline, {
    alignBlock: "center",
    alignInline: "center",
    space: "space.100",
    shouldWrap: false,
    children: /*#__PURE__*/_jsxs(Heading, {
      children: ["Discover apps for your\xA0", /*#__PURE__*/_jsx(TextUnderline, {
        underlineInset: "-60%",
        underline: /*#__PURE__*/_jsx("svg", {
          width: "100%",
          height: "30",
          viewBox: "0 0 306 42",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/_jsx("path", {
            d: "M0.314542 22.3672C52.9464 14.9125 91.8245 33.6666 144.966 18.1254C147.46 24.7349 153.892 33.0058 163.497 33.1094C155.486 32.9725 142.641 15.7178 155.536 27.2686C163.119 36.0683 196.172 25.2364 170.842 32.944C188.334 31.2885 204.356 20.5339 216.163 10.9702C235.811 -2.65832 220.928 23.6737 235.178 36.8756C255.37 55.2242 316.463 7.29572 304.134 7.28816C296.296 13.2947 285.769 17.046 281.423 23.6985C204.757 63.1757 259.992 -9.72674 214.311 2.55426C139.744 53.2533 177.393 7.4163 133.572 10.6223C108.06 28.9946 -0.613806 0.46356 0.29434 22.3672L0.314542 22.3672Z",
            fill: "#FFA900"
          })
        }),
        children: "team"
      })]
    })
  })
});
export default H1HeadingBlock;